import React, { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { forgotPassword } from '../redux/AuthCRUD'
import { useIntl } from 'react-intl'
import { ReCaptchaButton } from '../../../../_template/layout/core/ReCaptchaButton'

const initialValues = {
  merchantId: "",
  username: ""
}

const forgotPasswordSchema = Yup.object().shape({
  merchantId: Yup.string()
    .matches(RegExp('^[0-9]*$'), 'Üye İşyeri Id rakam olmalı')
    .min(1, 'Minimum 1 symbols')
    .max(10, 'Maximum 10 symbols')
    .required('MerchantId is required'),
  username: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Username is required')
})

export function ForgotPassword() {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setHasErrors(undefined)
      setTimeout(() => {
        forgotPassword(parseInt(values.merchantId), values.username)
          .then(({ data }) => {
            if (data.status) {
              setHasErrors(false)
              setLoading(false)
            } else {
              setHasErrors(true)
              setStatus(data.message)
              setLoading(false)
              setSubmitting(false)
            }
          })
          .catch(() => {
            setHasErrors(true)
            setLoading(false)
            setSubmitting(false)
            setStatus('Bir hata alındı. Lütfen daha sonra tekrar deneyiniz.')
          })
      }, 1000)
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Şifrenizi mi unuttunuz ?</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>Şifrenizi sıfırlamak için sistemde tanımlı olan Üye İşyeri Numaranızı ve Kullanıcı Adınızı giriniz</div>
          {/* end::Link */}
        </div>

        {/* begin::Title */}
        {hasErrors === true && (
          <div className='mb-lg-15 alert alert-danger'>
            <div className='alert-text font-weight-bold'>
              {formik.status}
            </div>
          </div>
        )}

        {hasErrors === false && (
          <div className='mb-10 bg-light-info p-8 rounded'>
            <div className='text-info'>Eğer girmiş olduğunuz bilgiler doğruysa, şifre sıfırlama talebiniz Eposta adresinize gönderilmiştir.</div>
          </div>
        )}
        {/* end::Title */}


        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fs-6 fw-bolder text-dark'>Üye İşyeri No</label>
          <input
            placeholder='Üye İşyeri No'
            {...formik.getFieldProps('merchantId')}
            className={clsx(
              'form-control form-control-lg',
              { 'is-invalid': formik.touched.merchantId && formik.errors.merchantId },
              {
                'is-valid': formik.touched.merchantId && !formik.errors.merchantId,
              }
            )}
            type='text'
            name='merchantId'
            autoComplete='off'
          />
          {formik.touched.merchantId && formik.errors.merchantId && (
            <div className='fv-plugins-message-container invalid-feedback'>
              <span role='alert'>{formik.errors.merchantId}</span>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fs-6 fw-bolder text-dark'>{intl.formatMessage({ id: 'AUTH.INPUT.USERNAME' })}</label>
          <input
            placeholder={intl.formatMessage({ id: 'AUTH.INPUT.USERNAME' })}
            {...formik.getFieldProps('username')}
            className={clsx(
              'form-control form-control-lg',
              { 'is-invalid': formik.touched.username && formik.errors.username },
              {
                'is-valid': formik.touched.username && !formik.errors.username,
              }
            )}
            type='text'
            name='username'
            autoComplete='off'
          />
          {formik.touched.username && formik.errors.username && (
            <div className='fv-plugins-message-container invalid-feedback'>
              <span role='alert'>{formik.errors.username}</span>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>

          <ReCaptchaButton
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
            disabled={formik.isSubmitting || !formik.isValid}
            loading={loading}
            spanClassName='indicator-label'
            text='Şifremi Sıfırla'
            actionName='FORGOTPASSWORD'
          />
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
            >
              Geri
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
